import { caseInsensitiveSort } from '@/lib/sort';
import type { Reminder, State } from './types';

export type Mutation =
  | { type: 'setReminders'; data: Reminder[] }
  | { type: 'addReminder'; data: Reminder }
  | { type: 'dismissReminder'; id: string }
  | { type: 'replaceReminder'; data: Reminder };

export function reducer(state: State, action: Mutation): State {
  switch (action.type) {
    case 'setReminders':
      return setReminders(state, action);
    case 'replaceReminder':
      return replaceReminder(state, action);
    case 'addReminder':
      return addReminder(state, action);
    case 'dismissReminder':
      return dismissReminder(state, action);
    default:
      return state;
  }
}

function setReminders(_state: State, { data }: { data: Reminder[] }): State {
  const all = data.sort(caseInsensitiveSort(['data.due_at', 'data.note']));

  return {
    loaded: true,
    list: all,
  };
}

function addReminder(state: State, { data }: { data: Reminder }): State {
  const newList = [...state.list, data];

  return {
    ...state,
    list: newList.sort(caseInsensitiveSort(['data.due_at', 'data.note'])),
  };
}

function dismissReminder(state: State, { id }: { id: string }): State {
  return {
    ...state,
    list: state.list.filter((item: Reminder) => item.id !== id),
  };
}

function replaceReminder(state: State, { data }: { data: Reminder }): State {
  const index = state.list.findIndex((item: Reminder) => item.id === data.id);
  if (index === -1) {
    return state;
  }

  const newList = [
    ...state.list.slice(0, index),
    data,
    ...state.list.slice(index + 1),
  ];
  newList[index] = data;

  return {
    ...state,
    list: newList,
  };
}
